(function () {
  'use strict';

  function initNewsArticle(root) {
    if (root.dataset.newsInitialized === 'true') return;
    root.dataset.newsInitialized = 'true';

    var content = root.querySelector('[data-news-content]');
    var body = root.querySelector('[data-news-body]');

    /* Key Takeaways: put the opening hook + the takeaway list into an
       IN BRIEF style box when the author left them unwrapped. */
    function isTakeawayHeading(el) {
      return !!el && /^H[1-6]$/.test(el.tagName) && /key\s*takeaways?/i.test(el.textContent.trim());
    }

    function isDivider(el) {
      if (!el) return false;
      if (el.tagName === 'HR') return true;
      if (el.tagName === 'DIV') {
        var inner = el.querySelector('hr');
        return !!inner && el.textContent.trim().length === 0;
      }
      return false;
    }

    function isAnchorTarget(el) {
      return !!el && el.tagName === 'A' && el.textContent.trim().length === 0;
    }

    function isList(el) {
      return !!el && (el.tagName === 'OL' || el.tagName === 'UL');
    }

    function looksLikeHook(el) {
      if (!el) return false;
      if (el.tagName === 'P') return true;
      if (el.tagName === 'BLOCKQUOTE') return true;
      if (el.tagName === 'DIV') {
        if (el.querySelector('hr, table, ol, ul, h1, h2, h3, h4, h5, h6, script')) return false;
        return el.textContent.trim().length > 0 && el.textContent.trim().length < 500;
      }
      return false;
    }

    function wrapTakeaways(content) {
      Array.prototype.slice.call(content.querySelectorAll('h1, h2, h3, h4, h5, h6'))
        .filter(isTakeawayHeading)
        .forEach(function (heading) {
          if (heading.closest('.quick-overview') || heading.closest('.key-points')) return;

          var parent = heading.parentElement;

          /* case 1: the author already boxed it with inline styles - reuse that box */
          if (parent && parent !== content && parent.tagName === 'DIV' && parent.querySelector('ol, ul')) {
            parent.classList.add('quick-overview');
            parent.style.background = '';
            parent.style.backgroundColor = '';
            parent.style.padding = '';
            parent.style.borderRadius = '';
            return;
          }

          /* case 2: build the box ourselves */
          var nodes = [heading];

          var next = heading.nextElementSibling;
          if (isList(next)) nodes.push(next);

          var hookChars = 0;
          var prev = heading.previousElementSibling;
          while (prev && nodes.length < 8) {
            if (isAnchorTarget(prev)) {
              prev = prev.previousElementSibling;
              continue;
            }
            if (/^H[1-6]$/.test(prev.tagName)) break;
            if (isDivider(prev)) {
              nodes.unshift(prev);
            } else if (looksLikeHook(prev)) {
              var chars = prev.textContent.trim().length;
              if (prev.tagName === 'P' && hookChars + chars > 900) break;
              hookChars += chars;
              nodes.unshift(prev);
            } else {
              break;
            }
            prev = nodes[0].previousElementSibling;
          }

          if (nodes.length < 2) return;
          var box = document.createElement('div');
          box.className = 'quick-overview';
          heading.parentNode.insertBefore(box, nodes[0]);
          nodes.forEach(function (node) { box.appendChild(node); });
        });
    }

    var tocLists = Array.prototype.slice.call(root.querySelectorAll('[data-news-toc]'));
    var quickNav = root.querySelector('.news-article__quick-nav');
    var tocColumn = root.querySelector('.news-article__toc-column');
    var stickyToc = root.querySelector('.news-article__sticky-toc');
    if (!content || !body) return;

    wrapTakeaways(content);

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2')).filter(function (heading) {
      return heading.textContent.trim().length > 0 && !heading.closest('.key-points, .editorial-note') && !heading.closest('.quick-overview') && !/newsletter-compact/.test(heading.className);
    });
    var tocLinks = [];
    var usedIds = {};

    headings.forEach(function (heading) {
      if (heading.id) usedIds[heading.id] = true;
    });

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var baseId = 'section-' + (index + 1);
        var nextId = baseId;
        var suffix = 2;
        while (usedIds[nextId] || document.getElementById(nextId)) {
          nextId = baseId + '-' + suffix;
          suffix += 1;
        }
        heading.id = nextId;
        usedIds[nextId] = true;
      }

      tocLists.forEach(function (list) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        var number = document.createElement('span');
        var label = document.createElement('span');
        link.className = 'news-article__toc-link';
        link.href = '#' + heading.id;
        link.dataset.newsTarget = heading.id;
        number.className = 'news-article__toc-number';
        number.textContent = String(index + 1).padStart(2, '0');
        number.setAttribute('aria-hidden', 'true');
        label.textContent = heading.textContent.trim();
        link.appendChild(number);
        link.appendChild(label);
        item.appendChild(link);
        list.appendChild(item);
        tocLinks.push(link);
      });
    });

    root.dataset.hasToc = headings.length > 0 ? 'true' : 'false';

    function setActive(id) {
      tocLinks.forEach(function (link) {
        var active = link.dataset.newsTarget === id;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    if (headings.length) {
      setActive(headings[0].id);
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var visible = entries.filter(function (entry) { return entry.isIntersecting; });
          if (visible.length) {
            visible.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
            setActive(visible[0].target.id);
          }
        }, { rootMargin: '-15% 0px -65% 0px', threshold: 0 });
        headings.forEach(function (heading) { observer.observe(heading); });
      }
    }

    tocLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        setActive(link.dataset.newsTarget);
        if (quickNav && quickNav.contains(link)) quickNav.removeAttribute('open');
      });
    });

    function updateTocPosition() {
      if (!tocColumn || !stickyToc) return;
      if (window.innerWidth <= 760 || !headings.length) {
        tocColumn.style.removeProperty('height');
        stickyToc.style.removeProperty('position');
        stickyToc.style.removeProperty('top');
        stickyToc.style.removeProperty('left');
        stickyToc.style.removeProperty('width');
        return;
      }

      var bodyTop = window.scrollY + body.getBoundingClientRect().top;
      var bodyHeight = body.offsetHeight;
      var tocHeight = stickyToc.offsetHeight;
      var topOffset = 112;
      tocColumn.style.height = bodyHeight + 'px';
      var columnRect = tocColumn.getBoundingClientRect();
      var start = bodyTop - topOffset;
      var end = bodyTop + bodyHeight - tocHeight - topOffset;

      if (window.scrollY < start) {
        stickyToc.style.position = 'absolute';
        stickyToc.style.top = '0px';
        stickyToc.style.left = '0px';
        stickyToc.style.width = '100%';
      } else if (window.scrollY > end) {
        stickyToc.style.position = 'absolute';
        stickyToc.style.top = Math.max(bodyHeight - tocHeight, 0) + 'px';
        stickyToc.style.left = '0px';
        stickyToc.style.width = '100%';
      } else {
        stickyToc.style.position = 'fixed';
        stickyToc.style.top = topOffset + 'px';
        stickyToc.style.left = columnRect.left + 'px';
        stickyToc.style.width = columnRect.width + 'px';
      }
    }

    var readingTime = root.querySelector('[data-news-reading-time]');
    if (readingTime) {
      var textCopy = content.cloneNode(true);
      Array.prototype.slice.call(textCopy.querySelectorAll('.news-collection-card, .news-product-card, script, style')).forEach(function (node) {
        node.parentNode.removeChild(node);
      });
      var words = textCopy.textContent.trim().split(/\s+/).filter(Boolean).length;
      var minutes = Math.max(1, Math.ceil(words / 200));
      readingTime.textContent = minutes + ' min read';
    }

    var ticking = false;
    function updateProgress() {
      var rect = body.getBoundingClientRect();
      var total = Math.max(body.offsetHeight - window.innerHeight, 1);
      var read = Math.min(Math.max(-rect.top + 110, 0), total);
      root.style.setProperty('--news-reading-progress', (read / total * 100).toFixed(2) + '%');
      updateTocPosition();
      ticking = false;
    }
    function requestProgress() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateProgress);
      }
    }
    document.addEventListener('scroll', requestProgress, { passive: true });
    window.addEventListener('resize', requestProgress);
    window.addEventListener('load', requestProgress);
    updateProgress();
  }

  function initAllNewsArticles() {
    Array.prototype.slice.call(document.querySelectorAll('[data-news-article]')).forEach(initNewsArticle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllNewsArticles);
  else initAllNewsArticles();

  document.addEventListener('shopify:section:load', function (event) {
    Array.prototype.slice.call(event.target.querySelectorAll('[data-news-article]')).forEach(initNewsArticle);
  });
})();
